import React from 'react';
import { Box, List } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import StatsIcon from '@mui/icons-material/QueryStats';
import NavListItem from '../../atoms/NavListItem/NavListItem';
import ExpandableNavListItem from '../../atoms/ExpandableNavListItem/ExpandableNavListItem';
import SubNavListItem from '../../atoms/SubNavListItem/SubNavListItem';
import { LeagueType, useLeagueContext } from '../../contexts/LeagueContext';
import ROUTER_URLS from '../../utils/router/urls';


function DrawerLinks() {
  const leagueContext: any = useLeagueContext();
  const league: LeagueType = leagueContext?.selectedLeague?.toLowerCase() || 'nba';

  const routes = ROUTER_URLS[league];

  return (
    <Box overflow='auto' paddingTop={2}>
      <List>
        <NavListItem text="My Dashboard" Icon={<HomeIcon />} path="/dashboard" />
        <ExpandableNavListItem text="Player Query Tools" Icon={<StatsIcon />}>
          <SubNavListItem text="Game Finder" path={routes.playerGameFinderSearch} />
          <SubNavListItem text="Streak Finder" path={routes.playerStreakFinderSearch} />
          <SubNavListItem text="Span Finder" path={routes.playerSpanFinderSearch} />
          { league === 'nba' && <SubNavListItem text="Consec Pts Finder" path={routes.playerConsecutivePointsFinderSearch} /> }
        </ExpandableNavListItem>
        <ExpandableNavListItem text="Team Query Tools" Icon={<StatsIcon />}>
          <SubNavListItem text="Game Finder" path={routes.teamGameFinderSearch} />
          <SubNavListItem text="Streak Finder" path={routes.teamStreakFinderSearch} />
          <SubNavListItem text="Span Finder" path={routes.teamSpanFinderSearch} />
          { league === 'nba' && <SubNavListItem text="Runs Finder" path={routes.runsFinderSearch} /> }
          { league === 'nba' && <SubNavListItem text="Comebacks Finder" path={routes.comebacksFinderSearch} /> }
        </ExpandableNavListItem>
      </List>
    </Box>
  );
}

export default DrawerLinks;
